import { History } from "history";

import {
  CreateLessonRequest,
  PaginateQuery,
  UpdateLessonRequest,
  LessonDto,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Lessons

export const GET_LESSONS = "GET_LESSONS";
export const GET_LESSONS_SUCCESS: any = "GET_LESSONS_SUCCESS";
export const GET_LESSONS_ERROR: any = "GET_LESSONS_ERROR";

export interface GetLessonsAction {
  type: typeof GET_LESSONS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetLessonsSuccessAction {
  type: typeof GET_LESSONS_SUCCESS;
  payload: Paginated<LessonDto>;
}

export interface GetLessonsErrorAction {
  type: typeof GET_LESSONS_ERROR;
  payload: any;
}
//#endregion

//#region Get Lesson

export const GET_LESSON = "GET_LESSON";
export const GET_LESSON_SUCCESS: any = "GET_LESSON_SUCCESS";
export const GET_LESSON_ERROR: any = "GET_LESSON_ERROR";

export interface GetLessonAction {
  type: typeof GET_LESSON;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetLessonSuccessAction {
  type: typeof GET_LESSON_SUCCESS;
  payload: LessonDto;
}

export interface GetLessonErrorAction {
  type: typeof GET_LESSON_ERROR;
  payload: any;
}
//#endregion

//#region Get Lesson Detail

export const GET_LESSON_DETAIL = "GET_LESSON_DETAIL";
export const GET_LESSON_DETAIL_SUCCESS: any = "GET_LESSON_DETAIL_SUCCESS";
export const GET_LESSON_DETAIL_ERROR: any = "GET_LESSON_DETAIL_ERROR";

export interface GetLessonDetailAction {
  type: typeof GET_LESSON_DETAIL;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetLessonDetailSuccessAction {
  type: typeof GET_LESSON_DETAIL_SUCCESS;
  payload: LessonDto;
}

export interface GetLessonDetailErrorAction {
  type: typeof GET_LESSON_DETAIL_ERROR;
  payload: any;
}
//#endregion

//#region Add Lesson

export const ADD_LESSON = "ADD_LESSON";
export const ADD_LESSON_SUCCESS: any = "ADD_LESSON_SUCCESS";
export const ADD_LESSON_ERROR: any = "ADD_LESSON_ERROR";

export interface AddLessonAction {
  type: typeof ADD_LESSON;
  payload: {
    request: CreateLessonRequest;
    history: History;
  };
}

export interface AddLessonSuccessAction {
  type: typeof ADD_LESSON_SUCCESS;
  payload: null;
}

export interface AddLessonErrorAction {
  type: typeof ADD_LESSON_ERROR;
  payload: any;
}
//#endregion

//#region Update Lesson

export const UPDATE_LESSON = "UPDATE_LESSON";
export const UPDATE_LESSON_SUCCESS: any = "UPDATE_LESSON_SUCCESS";
export const UPDATE_LESSON_ERROR: any = "UPDATE_LESSON_ERROR";

export interface UpdateLessonAction {
  type: typeof UPDATE_LESSON;
  payload: {
    id: string;
    request: UpdateLessonRequest;
    history: History;
  };
}

export interface UpdateLessonSuccessAction {
  type: typeof UPDATE_LESSON_SUCCESS;
  payload: null;
}

export interface UpdateLessonErrorAction {
  type: typeof UPDATE_LESSON_ERROR;
  payload: any;
}
//#endregion

//#region Delete Lesson

export const DELETE_LESSON_CONSENT: any = "DELETE_LESSON_CONSENT";
export const DELETE_LESSON = "DELETE_LESSON";
export const DELETE_LESSON_SUCCESS: any = "DELETE_LESSON_SUCCESS";
export const DELETE_LESSON_ERROR: any = "DELETE_LESSON_ERROR";

export interface DeleteLessonConsentAction {
  type: typeof DELETE_LESSON_CONSENT;
  payload: string;
}

export interface DeleteLessonAction {
  type: typeof DELETE_LESSON;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteLessonSuccessAction {
  type: typeof DELETE_LESSON_SUCCESS;
  payload: null;
}

export interface DeleteLessonErrorAction {
  type: typeof DELETE_LESSON_ERROR;
  payload: any;
}
//#endregion

//#region Toggle Lesson State

export const TOGGLE_LESSON_STATE_CONSENT: any = "TOGGLE_LESSON_STATE_CONSENT";
export const TOGGLE_LESSON_STATE = "TOGGLE_LESSON_STATE";
export const TOGGLE_LESSON_STATE_SUCCESS: any = "TOGGLE_LESSON_STATE_SUCCESS";
export const TOGGLE_LESSON_STATE_ERROR: any = "TOGGLE_LESSON_STATE_ERROR";

export interface ToggleLessonStateConsentAction {
  type: typeof TOGGLE_LESSON_STATE_CONSENT;
  payload: string;
}

export interface ToggleLessonStateAction {
  type: typeof TOGGLE_LESSON_STATE;
  payload: {
    chapterId: string;
    lessonId: string;
  };
}

export interface ToggleLessonStateSuccessAction {
  type: typeof TOGGLE_LESSON_STATE_SUCCESS;
  payload: { chapterId: string; lessonId: string };
}

export interface ToggleLessonStateErrorAction {
  type: typeof TOGGLE_LESSON_STATE_ERROR;
  payload: any;
}
//#endregion

//#region chapter select list by subject

export const GET_LESSON_LIST_BY_CHAPTER = "GET_LESSON_LIST_BY_CHAPTER";
export const GET_LESSON_LIST_BY_CHAPTER_SUCCESS: any =
  "GET_LESSON_LIST_BY_CHAPTER_SUCCESS";
export const GET_LESSON_LIST_BY_CHAPTER_ERROR: any =
  "GET_LESSON_LIST_BY_CHAPTER_ERROR";

export const RESET_LESSON_LIST_BY_CHAPTER: any = "RESET_LESSON_LIST_BY_CHAPTER";

export interface GetLessonSelectListByChapterAction {
  type: typeof GET_LESSON_LIST_BY_CHAPTER;
  payload: { chapterId: string };
}

export interface GetLessonSelectListByChapterSuccessAction {
  type: typeof GET_LESSON_LIST_BY_CHAPTER_SUCCESS;
  payload: SelectListDto[];
}

export interface GetLessonSelectListByChapterErrorAction {
  type: typeof GET_LESSON_LIST_BY_CHAPTER_ERROR;
  payload: any;
}

export interface ResetLessonSelectListByChapterAction {
  type: typeof RESET_LESSON_LIST_BY_CHAPTER;
  payload: any;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetLessonsAction
  | GetLessonsSuccessAction
  | GetLessonsErrorAction
  | GetLessonAction
  | GetLessonSuccessAction
  | GetLessonErrorAction
  | GetLessonDetailAction
  | GetLessonDetailSuccessAction
  | GetLessonDetailErrorAction
  | AddLessonAction
  | AddLessonSuccessAction
  | AddLessonErrorAction
  | UpdateLessonAction
  | UpdateLessonSuccessAction
  | UpdateLessonErrorAction
  | DeleteLessonConsentAction
  | DeleteLessonAction
  | DeleteLessonSuccessAction
  | DeleteLessonErrorAction
  | ToggleLessonStateConsentAction
  | ToggleLessonStateAction
  | ToggleLessonStateSuccessAction
  | ToggleLessonStateErrorAction
  | GetLessonSelectListByChapterAction
  | GetLessonSelectListByChapterErrorAction
  | GetLessonSelectListByChapterSuccessAction
  | ResetLessonSelectListByChapterAction;
